// Simple global opener for the Android Beta Modal.
// Any component can call `openAndroidBetaModal()` to open the modal.
// The modal itself (AndroidBetaMount at app root) subscribes to this event.

const EVENT = "fotr:open-android-beta";

export function openAndroidBetaModal() {
  window.dispatchEvent(new Event(EVENT));
}

export function subscribeAndroidBetaOpen(handler) {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
